import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radio-unselected",
  "use": "radio-unselected-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"radio-unselected\">\n<g clip-path=\"url(#radio-unselected_clip0_1106_21103)\">\n<rect width=\"18\" height=\"18\" rx=\"9\" stroke=\"#616161\" />\n</g>\n<defs>\n<clipPath id=\"radio-unselected_clip0_1106_21103\">\n<rect width=\"18\" height=\"18\" rx=\"9\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol